module.exports = __webpack_public_path__ + "static/img/coupons.f29c55e8.png";